import React, { createContext, useCallback, useContext, useState } from 'react';

import PropTypes from 'prop-types';

import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';

const AlertContext = createContext();

export function useAlert() {
  return useContext(AlertContext);
}

export function AlertProvider({ children }) {
  const [alert, setAlert] = useState({
    open: false,
    message: '',
    severity: 'success',
    duration: 2000,
  });

  const showAlert = useCallback((message, severity = 'success', duration = 2000) => {
    setAlert({ open: true, message, severity, duration });
  }, []);

  const handleClose = (_, reason) => {
    if (reason === 'clickaway') return;
    setAlert(a => ({ ...a, open: false }));
  };

  return (
    <AlertContext.Provider value={showAlert}>
      {children}
      <Snackbar
        open={alert.open}
        autoHideDuration={alert.duration}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        sx={{ marginTop: '50px' }}
      >
        <Alert
          role="alert"
          onClose={handleClose}
          severity={alert.severity}
          variant="filled"
          sx={{
            width: '100%',
          }}
        >
          {alert.message}
        </Alert>
      </Snackbar>
    </AlertContext.Provider>
  );
}

AlertProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
